window.footerModule =
  window.footerModule ||
  (() => {
    let isInitialized = false;

    const handleClick = (e) => {
      const parent = e.currentTarget.parentElement;
      if (!parent) {
        return;
      }

      if (!parent.hasAttribute('expanded')) {
        parent.setAttribute('expanded', '');
      } else {
        parent.removeAttribute('expanded');
      }
    };

    const init = () => {
      if (isInitialized) {
        return;
      }

      const toggle = document.querySelector('.arjo-o-footer__motto-toggle');
      if (!!toggle) {
        toggle.addEventListener('click', handleClick);
        isInitialized = true;
      }
    };

    return { init };
  })();

window.footerModule.init();
